import React, { useEffect, useRef, useState } from 'react'
import './monthdtl.less'
import { Select, Input, ConfigProvider, Modal, Button } from 'antd'
import zhCN from 'antd/es/locale/zh_CN';
import { axiosPostAndHint, mask, queryAxios, unmask } from '../../../components/reqAndHint';
import ProTable, { ActionType, ProColumns } from '@ant-design/pro-table';
import { CaretDownOutlined, DownloadOutlined } from '@ant-design/icons'
import axios from '../../../utils/AxiosUtil';
import moment from 'moment';
import { useSelector } from 'react-redux'
import { monthstyle } from '../../../utils/info'
import MonthInvoice from './MonthInvoice.tsx';
import printJS from 'print-js'
const { Option } = Select;


// type DataSourceType = {
//     '序号': Number,
//     '票据号码': String,
//     '开立日': Date,
//     '票据名称': String,
//     '票据金额': Number,
//     '用途': String,
//     '来源地': String,
//     '身份': String,
// };


// 月捐款明细
export default function monthdtl() {
    const langValue = useSelector(state => state.langList.value)
    const actionRef = useRef<ActionType>();

    const [outland, setOutland] = useState(null);
    const [naturalLegal, setNaturalLegal] = useState(null);
    const [billDetailName, setbillDetailName] = useState(null);
    const [month, setMonth] = useState(null);
    const [billDetailTable, setBillDetailTable] = useState(null);
    const [fileData, setFileData] = useState([]);
    const [yyyyMMArr, setyyyyMMArr] = useState([]);

    const [monthlyStatistics, setMonthlyStatistics] = useState(null); // 境外境内自然人法人捐款统计

    const [projectOpts, setProjectOpts] = useState([]); // 所有捐款项目

    const [chosenProject, setChosenProject] = useState(null); // 捐赠项目统计
    const [modalVisible, setModalVisible] = useState(false);
    const [monthlyProject, setMonthlyProject] = useState(null); // 捐赠项目统计
    // 预览表格 --- 统计月份数据 --- 按地区
    const handleDownload = () => {
        setModalVisible(true)
    }
    const InvoicePrint = () => {
        printJS({
            printable: 'monthInvoice',
            type: 'html',
            targetStyles: ['*'],
            documentTitle: `发票`,
            scanStyles: false,
            style: monthstyle
        })
    }
    //来源地筛选
    function handleOutlandChange(value) {
        // console.log(`handleOutlandChange ${value}`);
        setOutland(value);
        actionRef.current.reload();
    }

    //身份筛选
    function handleNaturalLegalChange(value) {
        // console.log(`handleNaturalLegalChange ${value}`);
        setNaturalLegal(value);
        actionRef.current.reload();
    }

    //关键词查询
    const onSearch = async (value) => {
        // console.log('onSearch:', value);
        setbillDetailName(value);
        actionRef.current.reload();
    }

    //切换月份
    function changeMonth(value) {
        // console.log(`changeMonth ${value}`);
        setMonth(value);
        let bdtbl = 'bill_detail_' + value;
        setBillDetailTable(bdtbl)
        actionRef.current.reload();
    }

    //来源地onchange
    function handleOriginChange(value, record) {
        // console.log("handleOriginChange:", value, record);
        axiosPostAndHint('/donation/changeOutland',
            { value, billCode: record['票据号码'], billDate: record['开立日'] },
            () => {
                getMonthlyStatistics();
                actionRef.current.reload()
            },
            () => { }, null);
    }

    //身份onchange
    function handleIdentityChange(value, record) {
        // console.log("handleIdentityChange:", value, record);
        axiosPostAndHint('/donation/changeNaturalOrLegal',
            { value, billCode: record['票据号码'], billDate: record['开立日'] },
            () => {
                getMonthlyStatistics();
                actionRef.current.reload()
            },
            () => { }, null);
    }

    // 选择的捐款项目
    const projectOptOnChange = (value) => {
        // console.log('projectOptOnChange:', value);
        setChosenProject(value);
    }

    //月份选项
    async function getyyyyMMTBL() {
        let result = await axios.post('/fund/donation/getyyyyMM');
        let arr = [];
        result ?.data ?.yyyyMMArr.forEach(element => {
            let str = element.split('_');
            arr.push(str[2]);
        });
        setyyyyMMArr(arr);
    }

    // 境内/境外 自然人/法人 合计和笔数
    const getMonthlyStatistics = async () => {
        let data = await axios.post('/fund/donation/monthlyStatistics', { billDetailTable });
        // console.log('getMonthlyStatistics:', data?.data);
        setMonthlyStatistics(data ?.data);
    }

    // 获取所有项目名
    const getProjectOpt = async () => {
        let data = await axios.post('/fund/project/getAll');
        // console.log('getProjectOpt:', data?.data);
        let projectArr = []
        data.data.forEach(item => {
            var obj = {
                ch_pro: item,
                en_pro: item
            }
            projectArr.push(obj)
        })
        setProjectOpts(projectArr)
    }

    // 获取月捐款项目统计 合计和笔数
    const getMonthlyProject = async () => {
        mask();
        let data = await axios.post('/fund/donation/monthlyProject', { billDetailTable, purpose: chosenProject });
        // console.log('getMonthlyProject:', data?.data);
        setMonthlyProject(data ?.data)
        unmask();
    }


    useEffect(() => {
        getyyyyMMTBL();
        getMonthlyStatistics();
        getProjectOpt();

    }, [billDetailTable])


    useEffect(() => {
        getMonthlyProject();

    }, [chosenProject, billDetailTable])


    useEffect(() => {
        // 在组件卸载时执行
        return () => {
            setMonthlyStatistics(null);
            setyyyyMMArr([]);
        };
    }, [])


    const columns = [
        {
            title: '序号',
            en_title: 'S/N',
            ch_title: '序号',
            dataIndex: '序号',
        },
        {
            title: '票据号码',
            en_title: 'Ticket number',
            ch_title: '票据号码',
            dataIndex: '票据号码',
        },
        {
            title: '开立日',
            en_title: 'Issuance date',
            ch_title: '开立日',
            dataIndex: '开立日',
        },
        {
            title: '票据名称',
            en_title: 'Ticket name',
            ch_title: '票据名称',
            dataIndex: '票据名称',
        },
        {
            title: '票据金额',
            en_title: 'Ticket amount',
            ch_title: '票据金额',
            dataIndex: '票据金额',
        },
        {
            title: '用途',
            en_title: 'Purpose',
            ch_title: '用途',
            dataIndex: '用途',
        },
    ]
    const getColumns = (col) => {
        let newCol = [...col];
        newCol.forEach((item, i) => {
            if (i == 5) {
                item.render = (_, item2) => {
                    return <span>{item2['用途']}</span>
                }
            }
            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        return newCol;
    }
    // 中英切换
    var domesticStr, foreignStr, naturalStr, legalStr
    if (langValue == 0) {
        // domesticStr = (
        //     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        //         <span>境内</span>
        //         <span style={{ fontSize: '12px' }}>Domestic</span>
        //     </div>
        // )
        // foreignStr = (
        //     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        //         <span>境外</span>
        //         <span style={{ fontSize: '12px' }}>Foreign</span>
        //     </div>
        // )
        naturalStr = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>捐款合计/笔数：</span>
                <span style={{ fontSize: '12px' }}>Total donations/number:</span>
            </div>
        )
        // legalStr = (
        //     <div style={{ display: 'flex', flexDirection: 'column' }}>
        //         <span>法人捐款合计/笔数：</span>
        //         <span style={{ fontSize: '12px' }}>Total donations/number of legal person donations:</span>
        //     </div>
        // )

    } else if (langValue == 1) {
        domesticStr = (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span>境内</span>
            </div>
        )
        foreignStr = (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span>境外</span>
            </div>
        )
        naturalStr = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>捐款合计/笔数：</span>
            </div>
        )
        // legalStr = (
        //     <div style={{ display: 'flex', flexDirection: 'column' }}>
        //         <span>法人捐款合计/笔数：</span>
        //     </div>
        // )
    } else {
        domesticStr = (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{ fontSize: '12px' }}>Domestic</span>
            </div>
        )
        foreignStr = (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{ fontSize: '12px' }}>Foreign</span>
            </div>
        )
        naturalStr = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '12px' }}>Total donations/number of natural person donations:</span>
            </div>
        )
        legalStr = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '12px' }}>Total donations/number of legal person donations:</span>
            </div>
        )
    }

    return (
        <div className='month-donation-detail'>

            <div className='mddtl-header'>

                <div className='capital'>
                    <span className='title'>
                        {langValue == 0 ?
                            `${month ?.slice(0, 4)}年${month ?.slice(4, 6)}月捐款合計(已開票，菲幣)Total donations in ${month ?.slice(0, 4)} Year ${month ?.slice(4, 6)} Month (invoiced,PHP)`
                            : (langValue == 1 ? `${month ?.slice(0, 4)}年${month ?.slice(4, 6)}月捐款合計(已開票，菲幣)` : `Total donations in ${month ?.slice(0, 4)} Year ${month ?.slice(4, 6)} Month (invoiced,PHP)`)}
                    </span>
                    <Select
                        placeholder={langValue == 0 ? '切換月份Switching months' : (langValue == 1 ? '切換月份' : 'Switching months')}
                        onChange={changeMonth}
                        style={{ marginLeft: 12 }}
                    >
                        {yyyyMMArr ?.map((yM, i) => (
                            <Option key={i} value={yM}>{yM.slice(0, 4) + '-' + yM.slice(4, 6)}</Option>
                        ))}
                    </Select>
                </div>

                <div className='content'>

                    <div className='col'>
                        <div className='left box1'>
                            合计
                        </div>
                        <div className='right'>
                            <div className='r-title'>{naturalStr}</div>
                            <div className='r-content'>
                                {monthlyStatistics ?.mainland_natural['捐款合计'] || 0} / {monthlyStatistics ?.mainland_natural['笔数']}
                            </div>
                        </div>
                    </div>

                    {/* <div className='col'>
                        <div className='left box2'>{domesticStr}</div>
                        <div className='right'>
                            <div className='r-title'>{legalStr}</div>
                            <div className='r-content'>
                                {monthlyStatistics ?.mainland_legal['捐款合计'] || 0} / {monthlyStatistics ?.mainland_legal['笔数']}
                            </div>
                        </div>
                    </div>

                    <div className='col'>
                        <div className='left box3'>{foreignStr}
                        </div>
                        <div className='right'>
                            <div className='r-title'>{naturalStr}</div>
                            <div className='r-content'>
                                {monthlyStatistics ?.outland_natural['捐款合计'] || 0} / {monthlyStatistics ?.outland_natural['笔数']}
                            </div>
                        </div>
                    </div>

                    <div className='col'>
                        <div className='left box4'>{foreignStr}</div>
                        <div className='right'>
                            <div className='r-title'>{legalStr}</div>
                            <div className='r-content'>
                                {monthlyStatistics ?.outland_legal['捐款合计'] || 0} / {monthlyStatistics ?.outland_legal['笔数']}
                            </div>
                        </div>
                    </div> */}

                </div>

                <div className='capital'>
                    <span className='title'>
                        {langValue == 0 ?
                            `${month ?.slice(0, 4)}年${month ?.slice(4, 6)}月捐款项目统计(菲币)Statistics of donation items in ${month ?.slice(0, 4)} Year ${month ?.slice(4, 6)} Month (PHP)`
                            : (langValue == 1 ? `${month ?.slice(0, 4)}年${month ?.slice(4, 6)}月捐款项目统计(菲币)` : `Statistics of donation items in ${month ?.slice(0, 4)} Year ${month ?.slice(4, 6)} Month (PHP)`)}
                    </span>
                    <Select
                        style={{ marginLeft: 12 }}
                        placeholder={langValue == 0 ? '请选择捐款项目Please select a donation project' : (langValue == 1 ? '请选择捐款项目' : 'Please select a donation project')}
                        showSearch
                        allowClear
                        onChange={projectOptOnChange}
                    >
                        {projectOpts && projectOpts ?.map((p, i) => {
                            return <Option key={i} value={p ?.ch_pro}>{<>{p ?.ch_pro}</>}</Option>
                        })}
                    </Select>
                </div>

                <div className='content'>

                    <div className='col'>
                        <div className='left box1'>
                            项目
                        </div>
                        <div className='right'>
                            <div className='r-title'>{naturalStr}</div>
                            <div className='r-content'>
                                {monthlyProject ?.mainland_natural['捐款合计'] || 0} / {monthlyProject ?.mainland_natural['笔数']}
                            </div>
                        </div>
                    </div>

                    {/* <div className='col'>
                        <div className='left box2'>{domesticStr}</div>
                        <div className='right'>
                            <div className='r-title'>{legalStr}</div>
                            <div className='r-content'>
                                {monthlyProject ?.mainland_legal['捐款合计'] || 0} / {monthlyProject ?.mainland_legal['笔数']}
                            </div>
                        </div>
                    </div>

                    <div className='col'>
                        <div className='left box3'>{foreignStr}
                        </div>
                        <div className='right'>
                            <div className='r-title'>{naturalStr}</div>
                            <div className='r-content'>
                                {monthlyProject ?.outland_natural['捐款合计'] || 0} / {monthlyProject ?.outland_natural['笔数']}
                            </div>
                        </div>
                    </div>

                    <div className='col'>
                        <div className='left box4'>{foreignStr}</div>
                        <div className='right'>
                            <div className='r-title'>{legalStr}</div>
                            <div className='r-content'>
                                {monthlyProject ?.outland_legal['捐款合计'] || 0} / {monthlyProject ?.outland_legal['笔数']}
                            </div>
                        </div>
                    </div> */}

                </div>

            </div>

            <div className='table-wrapper'>
                <div className='tb-header'>
                    <div className='capital'>
                        <span className='title'>
                            {langValue == 0 ?
                                `${month ?.slice(0, 4)}年${month ?.slice(4, 6)}月捐款明細 Details of donations in ${month ?.slice(0, 4)} Year ${month ?.slice(4, 6)} Month`
                                : (langValue == 1 ? `${month ?.slice(0, 4)}年${month ?.slice(4, 6)}月捐款明細` : `Details of donations in ${month ?.slice(0, 4)} Year ${month ?.slice(4, 6)} Month`)}
                        </span>
                    </div>
                </div>
                <div className='search-bar'>
                    <div className='s-item'>
                        <span>{langValue == 0 ? '收據名稱(Receipt Title)' : (langValue == 1 ? '收據名稱' : 'Receipt Title')}：</span>
                        <Input.Search
                            placeholder={langValue == 0 ? '請輸入關鍵詞Please enter keywords' : (langValue == 1 ? '請輸入關鍵詞' : 'Please enter keywords')}
                            style={{ marginRight: 0 }}
                            onSearch={onSearch}
                        />
                    </div>
                </div>

                <ConfigProvider locale={zhCN}>

                    <div className='donation-list'>
                        <ProTable
                            sticky
                            rowKey="序号"
                            actionRef={actionRef}
                            columns={getColumns(columns)}
                            cardBordered
                            // toolBarRender={false}
                            //工具栏选项
                            options={{
                                density: true,//工具栏选择表格密度
                                fullScreen: true,//工具栏允许全屏
                                reload: false,//工具栏刷新
                                setting: false,
                            }}
                            params={{
                                outland: outland,
                                naturalLegal: naturalLegal,
                                billDetailName: billDetailName,
                                billDetailTable: billDetailTable
                            }}
                            request={async (
                                // 第一个参数 params 查询表单和 params 参数的结合
                                // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                                params: {
                                    pageSize: number;
                                    current: number;
                                },
                                sort,
                                filter,
                            ) => {
                                // console.log(params);
                                let data = await queryAxios('/donation/monthlyList', params);
                                try {
                                    //没有指定月份时，自动显示当月
                                    if (!billDetailTable) {
                                        // let yearMonth = date2Str.format(new Date(), 'yyyyMM');
                                        let yearMonth = moment().format('YYYYMM');
                                        setMonth(yearMonth);
                                    }
                                    let donationData
                                    if (data) {
                                        donationData = [...data ?.data ?.data];
                                        // console.log('donationData:', donationData)
                                        donationData.forEach((d, i) => {
                                            d['序号'] = i + 1;
                                            d.en_proj = d['用途'];
                                        });
                                        setFileData(donationData)
                                    }
                                    return {
                                        data: donationData,
                                        // success 请返回 true，
                                        // 不然 table 会停止解析数据，即使有数据
                                        success: true,
                                        // 不传会使用 data 的长度，如果是分页一定要传
                                        total: donationData.length,
                                    };
                                } catch (error) {
                                    Modal.error({ content: '月捐款明細列表錯誤' });
                                }
                            }}
                            // editable={{
                            //     type: 'multiple',
                            // }}
                            // value={dataSource}
                            columnsState={{
                                persistenceKey: 'pro-table-singe-demos',
                                persistenceType: 'sessionStorage',
                            }}
                            search={false}
                            pagination={{
                                pageSize: 10,
                                pageSizeOptions: [10, 20, 50, 100, 1000],
                                showQuickJumper: true,
                                showSizeChanger: true,
                            }}
                            dateFormatter="string"
                            // headerTitle="筛选结果"
                            onRequestError={(error) => {
                                //请求error的回调处理
                                error = typeof error == 'object' ? JSON.stringify(error) : error;
                                Modal.error({ title: '表格加載錯誤' });
                            }}
                            toolbar={{
                                actions: [
                                    <Button style={{ height: '100%' }} type='primary' icon={<DownloadOutlined />}
                                        onClick={() => {
                                            handleDownload()
                                        }}
                                        disabled={fileData.length == 0}//没有数据时不能下载
                                    > {langValue == 0 ? <span>月項目報表<br />Monthly Project Report</span> : (langValue == 1 ? '月項目報表' : 'Monthly Project Report')}
                                    </Button>
                                ]
                            }}
                        />
                    </div>

                </ConfigProvider>
            </div>
            <Modal
                centered
                visible={modalVisible}
                onOk={InvoicePrint}
                okText={langValue == 0 ? '打印Print' : (langValue == 1 ? '打印' : 'Print')}
                cancelText={langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle')}
                onCancel={() => setModalVisible(false)}
                width={'auto'}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)
            >
                <MonthInvoice recordArr={fileData} />
            </Modal>
        </div>
    )
}
